// @ts-nocheck
import React, { useState, useEffect, useContext, useRef } from 'react';
import Head from 'next/head';
import Router, { useRouter } from 'next/router';
import LegacyButton from '@/components/button';
import ButtonDropdown from '@/components/button-dropdown';
import Breadcrumbs from '@/components/breadcrumbs';
import Tabs from '@/components/tabs';
import { colors } from '@/theme/';
import Fetch from '@/utils/Fetch';
import Helper from '@/utils/helper';
import ToastContext from '@/utils/toast-context';
import * as Enums from '@/utils/enums';
import Constants from '@/utils/constants';
import Attachments from '@/components/shared-views/attachments';
import Appointments from '@/components/shared-views/appointments';
import Communications from '@/components/shared-views/communications';
import Locations from '@/components/location/locations';
import Invoices from '@/components/shared-views/invoices';
import Products from '@/components/shared-views/products';
import ConfirmAction from '@/components/modals/confirm-action';
import OptionService from '@/services/option/option-service';
import Storage from '@/utils/storage';
import PS from '@/services/permission/permission-service';
import CustomerService from '@/services/customer/customer-service';
import IntegrationService from '@/services/integration-service';
import HelpDialog from '@/components/help-dialog';
import CustomerForm from "@/components/customer/CustomerDetails";
import CustomerStatusTag from "@/components/customer/CustomerStatusTag";
import FormDefinitionsForItem from '@/components/modals/form-definition/form-definitions-for-item';
import useRefState from "@/hooks/useRefState";
import {Box, Button, Card, Flex, Text} from "@mantine/core";
import {useElementSize} from "@mantine/hooks";
import ToolbarButtons from "@/PageComponents/Button/ToolbarButtons";
import {IconArchive, IconArchiveOff, IconDotsVertical, IconSend} from "@tabler/icons";
import {IconArrowBackUp, IconDeviceFloppy, IconEyeOff} from "@tabler/icons-react";
import ItemQuotesTable from "@/PageComponents/Table/Component Tables/ItemQuotesTable";
import ItemJobsTable from "@/PageComponents/Table/Component Tables/ItemJobsTable";
import ItemContactsTable from "@/PageComponents/Table/Component Tables/ItemContactsTable";
import CustomerLocationsTable from "@/PageComponents/Table/Component Tables/CustomerLocationsTable";
import ItemInvoicesTable from "@/PageComponents/Table/Component Tables/ItemInvoicesTable";
import ItemQueriesTable from "@/PageComponents/Table/Component Tables/ItemQueriesTable";
import ItemAssetsTable from "@/PageComponents/Table/Component Tables/ItemAssetsTable";
import AlertIcon from "@/PageComponents/Icons/AlertIcon";
import QuoteDrawer from "@/PageComponents/Quote/QuoteDrawer";
import {useQuery} from "@tanstack/react-query";
import InvoiceDrawer from "@/PageComponents/Invoice/InvoiceDrawer";
import { createFileRoute } from '@tanstack/react-router'
import DetailsPageLoader from '@/components/details-page-loader'

function CustomerPage() {

  const router = useRouter();
  const { id, tab } = router.query;
 // TODO(tanstack-router): verify router.query → useParams/useSearch

  const { data: customerData } = useQuery(
    ['customer', id],
    () => CustomerService.getCustomer(id),
    { enabled: !!id }
  );

  const { data: countsData } = useQuery(
    ['customerCounts', id],
    () => CustomerService.getCounts(id),
    { enabled: !!id }
  );

  const { data: customFields } = useQuery(
    ['customFields', Enums.Module.Customer],
    () => OptionService.getCustomFields(Enums.Module.Customer)
  );

  const [customer, setCustomer] = useState<any>(null);

  const toast = useContext(ToastContext);

  const jobPermission = PS.hasPermission(Enums.PermissionName.Job);
  const quotePermission = PS.hasPermission(Enums.PermissionName.Quote);
  const invoicePermission = PS.hasPermission(Enums.PermissionName.Invoice);
  const queryPermission = PS.hasPermission(Enums.PermissionName.Query);
  const productPermission = PS.hasPermission(Enums.PermissionName.Product);
  const appointmentPermission = PS.hasPermission(Enums.PermissionName.Appointment);
  const editCustomerPermission = PS.hasPermission(Enums.PermissionName.EditCustomer);

  const [pageTabs, setPageTabs] = useState<any[]>([]);

  const [selectedTab, setSelectedTab] = useState<any>(null);
  const [saving, setSaving] = useState(false);
  // const [comments, setComments] = useState<any[]>([]);

  const [selectedCustomerType, setSelectedCustomerType] = useState<any>(null);
  const [selectedIndustryType, setSelectedIndustryType] = useState<any>(null);
  const [selectedMediaType, setSelectedMediaType] = useState<any>(null);
  const [selectedCustomerStatus, setSelectedCustomerStatus] = useState<any>(null);

  const doSetSelectedCustomerType = (newVal: any) => {
    setSelectedCustomerType(newVal);
    setFormIsDirty(true);
  };

  const doSetSelectedIndustryType = (newVal: any) => {
    setSelectedIndustryType(newVal);
    setFormIsDirty(true);
  };

  const doSetSelectedMediaType = (newVal: any) => {
    setSelectedMediaType(newVal);
    setFormIsDirty(true);
  };

  const doSetSelectedCustomerStatus = (newVal: any) => {
    setSelectedCustomerStatus(newVal);
    setFormIsDirty(true);
  };

  const [formIsDirty, setFormIsDirty] = useRefState(false);
  const [cclDirty, setCclDirty] = useRefState(false);
  const [confirmOptions, setConfirmOptions] = useState(Helper.initialiseConfirmOptions());

  Helper.preventRouteChange(formIsDirty, setFormIsDirty, setConfirmOptions, saveCustomer, true);

  const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);

  const [saveDisabled, setSaveDisabled] = useState(false);

  const getAccessStatus = () => {
    let subscriptionInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
    if (subscriptionInfo) {
      setAccessStatus(subscriptionInfo.AccessStatus);
    }

    // preparing permissions relevant to buttons that are misbehaving
    let disable = subscriptionInfo?.AccessStatus === Enums.AccessStatus.LockedWithAccess || subscriptionInfo?.AccessStatus === Enums.AccessStatus.LockedWithOutAccess;
    let disableSave = !PS.hasPermission(Enums.PermissionName.EditCustomer) || disable;
    setSaveDisabled(disableSave);
  };

  useEffect(() => {
    if (accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
      Helper.nextRouter(Router.replace, "/");
    }
  }, [accessStatus]);

  const [contactCount, setContactCount] = useState(0);
  const [locationCount, setLocationCount] = useState(0);
  const [jobCount, setJobCount] = useState(0);
  const [quoteCount, setQuoteCount] = useState(0);
  const [invoiceCount, setInvoiceCount] = useState(0);
  const [queryCount, setQueryCount] = useState(0);
  const [productCount, setProductCount] = useState(0);
  const [appointmentCount, setAppointmentCount] = useState(0);
  const [attachmentCount, setAttachmentCount] = useState(0);
  const [communicationCount, setCommunicationCount] = useState(0);

  const [countsToggle, setCountsToggle] = useState(false);

  const getCounts = async () => {
    if (!customer) return;
    let counts = await CustomerService.getCounts(customer.ID);
    setContactCount(counts.contactCount);
    setLocationCount(counts.locationCount);
    setJobCount(counts.jobCount);
    setQuoteCount(counts.quoteCount);
    setInvoiceCount(counts.invoiceCount);
    setQueryCount(counts.queryCount);
    setProductCount(counts.productCount);
    setAppointmentCount(counts.appointmentCount);
    setAttachmentCount(counts.attachmentCount);
    setCommunicationCount(counts.communicationCount);

    setCountsToggle(!countsToggle);
  };

  useEffect(() => {
    buildUpPageTabs();
  }, [countsToggle]);

  const buildUpPageTabs = () => {
    let tabs = [
      { text: 'Details', count: '0' },
      { text: 'Contacts', count: contactCount },
      { text: 'Locations', count: locationCount }];

    if (jobPermission && jobCount > 0)
      tabs.push({ text: 'Jobs', count: jobCount });
    if (quotePermission && quoteCount > 0)
      tabs.push({ text: 'Quotes', count: quoteCount });
    if (invoicePermission && invoiceCount > 0)
      tabs.push({ text: 'Invoices', count: invoiceCount });
    if (queryPermission && queryCount > 0)
      tabs.push({ text: 'Queries', count: queryCount });
    if (productPermission && productCount > 0)
      tabs.push({ text: 'Assets', count: productCount });
    if (appointmentPermission)
      tabs.push({ text: 'Appointments', count: appointmentCount });

    tabs.push(...[{ text: 'Attachments', count: attachmentCount },
    { text: 'Messages', count: communicationCount }]);

    setPageTabs(tabs);
  }

  useEffect(() => {
    getAccessStatus();
    getIntegration();
  }, []);

  const onAppointmentRefresh = () => {
    getCounts();
  };

  const onAttachmentRefresh = () => {
    getCounts();
  };

  const getCustomerStatus = async (cust: any) => {
    if (cust && cust.CustomerStatusID) {
      const response = await Fetch.get({
        url: `/CustomerStatus/${cust.CustomerStatusID}`,
      });
      setSelectedCustomerStatus(response);
    }
  };

  const [contacts, setContacts] = useState<any[]>([]);
  const [locations, setLocations] = useState<any[]>([]);

  // Reset state on ID change — must be declared BEFORE data init effects
  useEffect(() => {
    if (id) {
      setCustomer(null);
      setSelectedTab(null);
    }
  }, [id]);

  // Initialize customer data from query
  useEffect(() => {
    if (customerData && !customer) {
      setCustomer(customerData);
      setContacts(customerData.Contacts || []);
      setLocations(customerData.Locations || []);
      setSelectedCustomerType(customerData.CustomerType);
      setSelectedIndustryType(customerData.IndustryType);
      setSelectedMediaType(customerData.MediaType);
      setSelectedCustomerStatus(customerData.CustomerStatus);
      getCustomerStatus(customerData);
    }
  }, [customerData]);

  // Initialize counts from query
  useEffect(() => {
    if (countsData) {
      setContactCount(countsData.contactCount);
      setLocationCount(countsData.locationCount);
      setJobCount(countsData.jobCount);
      setQuoteCount(countsData.quoteCount);
      setInvoiceCount(countsData.invoiceCount);
      setQueryCount(countsData.queryCount);
      setProductCount(countsData.productCount);
      setAppointmentCount(countsData.appointmentCount);
      setAttachmentCount(countsData.attachmentCount);
      setCommunicationCount(countsData.communicationCount);
      setCountsToggle((t: any) => !t);
    }
  }, [countsData]);

  // Initialize tab from URL
  useEffect(() => {
    if (selectedTab === null && router.isReady) {
      const tabMap = { communication: 'Messages', contacts: 'Contacts', locations: 'Locations' };
      setSelectedTab(tabMap[tab] || 'Details');
    }
  }, [router.isReady, tab, id]);

  async function updateCustomer(field: any, value: any) {

    let newCustomerState = { ...customer };
    newCustomerState[field] = value;
    setCustomer(newCustomerState);

    if (field == "Contacts") {
      setContacts(value);
    }

    if (field == "Locations") {
      setLocations(value);
    }

    getCounts();
    setFormIsDirty(true);
  }

  // INTEGRATION

  const [integration, setIntegration] = useState<any>();
  const [integrationTooltip, setIntegrationTooltip] = useState('');

  const getIntegration = async () => {
    let integration = await IntegrationService.getIntegration();
    if (integration) {
      setIntegrationTooltip((integration as any).Status == Enums.IntegrationStatus.Live ? ''
        : `Customer on ${Enums.getEnumStringValue(Enums.IntegrationPartner, (integration as any).Partner)} has status of ${Enums.getEnumStringValue(Enums.IntegrationStatus, (integration as any).Status)}`);
    }
    setIntegration(integration);
  };

  const syncCustomer = async () => {
    const result = await Fetch.post({
      url: `/Customer/CustomerSync?customerID=${customer.ID}`,
      toastCtx: toast
    });
    if (result.ID) {
      toast.setToast!!!({
        message: 'Customer successfully queued for sync',
        show: true,
        type: 'success'
      });
      setCustomer(result);
      setContacts(result.Contacts);
      setLocations(result.Locations);
    } else {
      toast.setToast!!!({
        message: 'Customer failed to sync',
        show: true,
        type: Enums.ToastType.error
      });
    }
  };

  const [inputErrors, setInputErrors] = useState<any>({});

  const validate = () => {

    let validationItems = [
      { key: 'CustomerName', value: customer.CustomerName, required: true, type: Enums.ControlType.Text },
      { key: 'DefaultDiscount', value: customer.DefaultDiscount, required: true, gte: 0, type: Enums.ControlType.Number },
    ];

    let { customerStatusRequired, customerTypeRequired, industryTypeRequired, mediaTypeRequired } =
      OptionService.getCustomerCustomFields(customFields);

    if (customerStatusRequired) {
      validationItems = [...validationItems,
      { key: 'CustomerStatus', value: selectedCustomerStatus, required: true, type: Enums.ControlType.Select },
      ];
    }

    if (customerTypeRequired) {
      validationItems = [...validationItems,
      { key: 'CustomerType', value: selectedCustomerType, required: true, type: Enums.ControlType.Select },
      ];
    }

    if (industryTypeRequired) {
      validationItems = [...validationItems,
      { key: 'IndustryType', value: selectedIndustryType, required: true, type: Enums.ControlType.Select },
      ];
    }

    if (mediaTypeRequired) {
      validationItems = [...validationItems,
      { key: 'MediaType', value: selectedMediaType, required: true, type: Enums.ControlType.Select },
      ];
    }

    const { isValid, errors } = Helper.validateInputs(validationItems);
    setInputErrors(errors);
    return isValid;
  };

  const [triggerSaveComment, setTriggerSaveComment] = useState(0);
  async function submitComment() {
    setTriggerSaveComment((x: any) => x + 1);
  }

  const [triggerFormSaveCounter, setTriggerFormSaveCounter] = useState(0)

  const changeRouteAfterSaveUrl = useRef<any>(null)

  async function saveCustomer(routeChangeUrl = null) {

    setTriggerFormSaveCounter((p: any) => p + 1)
    setSaving(true);

    changeRouteAfterSaveUrl.current = routeChangeUrl;

  }

  const handleSaveCustomer = async (values: any) => {

    await submitComment();

    let customerToSave = {
      ...customer,
      ...values,
      /* Now included in form
      CustomerTypeID: values.CustomerType ? values.CustomerType.ID : null,
      IndustryTypeID: values.IndustryType ? values.IndustryType.ID : null,
      MediaTypeID: values.MediaType ? values.MediaType.ID : null,
      CustomerStatusID: values.CustomerStatus ? values.CustomerStatus.ID : null,
      EmployeeID: values.Employee ? values.Employee.ID : null,*/
    }

    const customerPut = await Fetch.put({
      url: '/Customer',
      params: customerToSave,
      toastCtx: toast
    });

    if (customerPut.ID) {

      setCustomer(customerPut);
      setContacts(customerPut.Contacts);
      setLocations(customerPut.Locations);
      setFormIsDirty(false);
      setCclDirty(false);

      if (!changeRouteAfterSaveUrl.current) {
        toast.setToast!!!({
          message: 'Customer saved successfully',
          show: true,
          type: 'success'
        });
      } else {
        await Helper.waitABit(100)
        Helper.nextRouter(Router.push, changeRouteAfterSaveUrl.current);
      }
    }
    setSaving(false);
  }
  const handleErrors = () => {
    toast.setToast!!!({
      message: 'There are errors on the page',
      show: true,
      type: Enums.ToastType.error
    });
    setSaving(false);
  }

  const cancel = () => {
    Helper.nextRouter(Router.push, '/customer/list?tab=customers');
  };

  const [archiving, setArchiving] = useState(false);

  async function archiveCustomer() {
    setArchiving(true);

    const customerPut = await Fetch.put({
      url: '/Customer/Archive?id=' + customer.ID,
      toastCtx: toast
    });

    if (customerPut.ID) {
      const message = customerPut.IsArchived ? 'Customer archived successfully' : 'Customer un-archived successfully'
      toast.setToast!!!({
        action: 'Undo',
        actionFunc: async function () {
          const customerPutInner = await Fetch.put({
            url: '/Customer/Archive?id=' + customer.ID,
          });
          setCustomer(customerPutInner);
          setContacts(customerPutInner.Contacts);
          setLocations(customerPutInner.Locations);
          setFormIsDirty(false);
          setCclDirty(false);
        },
        message: message,
        show: true,
        type: 'success'
      });
      setCustomer(customerPut);
      setContacts(customerPut.Contacts);
      setLocations(customerPut.Locations);
      setFormIsDirty(false);
      setCclDirty(false);
    }

    setArchiving(false);
  }

  // Hiding/showing saves straight away (no Save button) and leaves unsaved Details edits pending:
  // the PUT is built from the stored customer, so pending field and primary changes aren't saved
  // with it, and only the status and RowVersion are copied back so they aren't discarded either.
  const [togglingActive, setTogglingActive] = useState(false);

  async function saveActive(isActive: boolean) {
    setTogglingActive(true);
    try {
      const stored = await Fetch.get({ url: '/Customer/' + customer.ID });
      if (!stored?.ID) return;
      // The page's RowVersion, so a change made elsewhere since this page loaded still fails the concurrency check
      const customerPut = await Fetch.put({
        url: '/Customer',
        params: { ...stored, RowVersion: customer.RowVersion, IsActive: isActive },
        toastCtx: toast
      });
      if (customerPut?.ID) {
        setCustomer((current: any) => ({
          ...current,
          IsActive: customerPut.IsActive,
          RowVersion: customerPut.RowVersion,
          ModifiedBy: customerPut.ModifiedBy,
          ModifiedDate: customerPut.ModifiedDate,
        }));
        toast.setToast!!!({
          message: `${customer.CustomerName} is ${customerPut.IsActive ? 'visible again' : 'now hidden'}`,
          show: true,
          type: 'success'
        });
      }
    } finally {
      setTogglingActive(false);
    }
  }

  const toggleActive = () => {
    if (!customer.IsActive) {
      saveActive(true);
      return;
    }
    setConfirmOptions({
      ...Helper.initialiseConfirmOptions(),
      display: true,
      heading: `Hide ${customer.CustomerName}?`,
      text: 'This customer won\'t display for you or anyone on your team. You can find them with the "Inactive Customers" filter on the customers list and show them again anytime.',
      confirmButtonText: 'Hide customer',
      onConfirm: () => saveActive(false),
    });
  };

  const [optionButtons, setOptionButtons] = useState<any[]>([]);

  // Customer forms open from the Options menu, as Forms does on the job page
  const [formDefinitions, setFormDefinitions] = useState<any[]>([]);
  const [showFormsModal, setShowFormsModal] = useState(false);

  useEffect(() => {
    Fetch.post({ url: `/FormDefinition/GetFormDefinitions`, params: {} } as any).then((request: any) => {
      setFormDefinitions((request?.Results ?? []).filter((x: any) => x.FormRule === Enums.FormRule.Customer));
    });
  }, []);

  const {data: companyDetails} = useQuery(['companyDetails'], () => Fetch.get({url: '/Company'}))
  const [selectedQuote, setSelectedQuote] = useState<any>(null)
  const [createNewQuote, setCreateNewQuote] = useState(false)
  const [createNewCopyQuote, setCreateNewCopyQuote] = useState<any>(null)
  const [selectedInvoice, setSelectedInvoice] = useState<any>(null)
  const [createNewInvoice, setCreateNewInvoice] = useState(false)
  const [createNewCopyInvoice, setCreateNewCopyInvoice] = useState<any>(null)

  const getOptionButtons = () => {
    let buttons = [
      ...(formDefinitions.length > 0 ? [{ text: 'Forms', link: `Forms` }] : []),
      { text: 'New Customer', link: `CreateCustomer` },
      { text: 'Send Customer zone link', link: `SendCustomerZoneLink` },
      { text: 'Copy Customer zone link', link: `CopyCustomerZoneLink` },
    ];

    if (jobPermission) {
      buttons.push({
        text: 'Create Job', link: `CreateJob`
      });
    }

    if (quotePermission) {
      buttons.push({
        text: 'Create Quote', link: `CreateQuote`
      });
    }

    if (invoicePermission) {
      buttons.push({
        text: 'Create Invoice', link: `CreateInvoice`
      });
    }

    if (queryPermission) {
      buttons.push({
        text: 'Create Query', link: `CreateQuery`
      });
    }

    if (productPermission) {
      buttons.push({
        text: 'Create Asset', link: `CreateAsset`
      });
    }

    setOptionButtons(buttons);
  };

  // Rebuilt once the customer form definitions load (Forms shows only when there are some)
  useEffect(() => {
    getOptionButtons();
  }, [formDefinitions]);

  const optionsClick = async (link: any) => {

    switch (link) {
      case 'Forms':
        setShowFormsModal(true)
        break;
      case 'CreateCustomer':
        Helper.nextRouter(Router.push, `/customer/create`)
        break;
      case 'SendCustomerZoneLink':
        Helper.nextRouter(Router.push, `/new-communication/${customer.ID}?moduleCode=${Enums.Module.Customer}&method=email&templateID=${Constants.templateIDs.TemplateCustomerZone}`)
        break;
      case 'CopyCustomerZoneLink': {
        const res = await Fetch.get({ url: `/Customer/GenerateCustomerZoneLink?customerID=${customer.ID}` });
        const czUrl = `${window.location.origin}/customerzone?token=${encodeURIComponent(res.token)}`;
        await navigator.clipboard.writeText(czUrl);
        toast.setToast!!!({ message: 'Customer zone link copied to clipboard', show: true, type: 'success' });
        break;
      }
      case 'CreateJob':
        Helper.nextRouter(Router.push, `/job/create?module=${Enums.Module.Customer}&moduleID=${customer.ID}&customerID=${customer.ID}`)
        break;
      case 'CreateQuote':
        setCreateNewQuote(true)
        break;
      case 'CreateInvoice':
        setCreateNewInvoice(true)
        break;
      case 'CreateQuery':
        Helper.nextRouter(Router.push, `/query/create?module=${Enums.Module.Customer}&moduleID=${customer.ID}&customerID=${customer.ID}`)
        break;
      case 'CreateAsset':
        Helper.nextRouter(Router.push, `/asset/create?module=${Enums.Module.Customer}&moduleID=${customer.ID}&customerID=${customer.ID}`)
        break;
    }
  };

  const fetchCustomerDetails = async () => {
    try {
      const cust = await Fetch.get({
        url: '/Customer/' + id,
        caller: "pages/customer/[id].js:fetchCustomerDetails()"
      });
      setCustomer(cust);
      setContacts(cust.Contacts);
      setLocations(cust.Locations);

      setSelectedCustomerType(cust.CustomerType);
      setSelectedIndustryType(cust.IndustryType);
      setSelectedMediaType(cust.MediaType);
      setSelectedCustomerStatus(cust.CustomerStatus);

      setFormIsDirty(false);
      setCclDirty(false);
      getCounts();
    } catch (error) {
      console.log('fetchCustomerDetails', error);
    }
  };

  const trySetSelectedTab = async (tab: any) => {
    if (tab !== selectedTab && tab === "Details") {
      await fetchCustomerDetails();
    }

    if (selectedTab === "Details" && tab !== "Details" && formIsDirty) {
      setConfirmOptions({
        ...Helper.initialiseConfirmOptions(),
        display: true,

        heading: "Save Changes?",
        text: "Save changes before changing the tab?",
        confirmButtonText: "Save Changes",
        discardButtonText: "Discard Changes",
        showDiscard: true,
        showCancel: true,
        onDiscard: async () => {
          await fetchCustomerDetails();
          setSelectedTab(tab);
        },
        onConfirm: async() => {
          let result = await saveCustomer();
          if (result === true) {
            setSelectedTab(tab);
          }
        }
      });
    } else {
      setSelectedTab(tab);
    }
  };

  const {height: toolbarHeight, ref: toolbarRef} = useElementSize()

  if (!customer || !customFields) return (
    <DetailsPageLoader
      tabWidths={[70, 85, 90, 60, 70, 80, 75, 65, 110, 100, 115]}
      actionWidths={[90, 90, 75, 65]}
    />
  );

  return (
    <div>
      <Head><title>{customer.CustomerCode} | Customers</title></Head>
      <Box bg={'white'} ref={toolbarRef}>
        <Flex justify={'apart'} w={'100%'} mt={'15px'} px={10}>
          <Flex align={'center'} gap={8}>
            <Breadcrumbs
                currPage={{text: customer.CustomerName, link: '/customer/' + customer.ID, type: 'customer-show'}}
            />
            <CustomerStatusTag
                isActive={customer.IsActive}
                isArchived={customer.IsArchived}
                disabled={!editCustomerPermission || togglingActive || saveDisabled}
                onToggleActive={toggleActive}
            />
          </Flex>

          <ToolbarButtons
              buttonGroups={[
                  [{
                    breakpoint: 1100,
                    type: 'menu',
                    disabled: accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess,
                    action: optionsClick,
                    text: 'Options',
                    icon: <IconDotsVertical />,
                    legacyOptions: optionButtons,
                  }],
                  [
                    {
                      breakpoint: 850,
                      type: 'button',
                      icon: customer.IsArchived ? <IconArchiveOff color={'var(--mantine-color-yellow-1)'} /> : <IconArchive color={'var(--mantine-color-yellow-7)'} />,
                      isBusy: archiving,
                      disabled: saveDisabled,
                      onClick: archiving ? null : archiveCustomer,
                      variant: customer.IsArchived ? 'filled' : 'outline',
                      color: customer.IsArchived ? 'gray' : 'gray.6',
                      text: customer.IsArchived ? (archiving ? "Un-archiving" : "Archived") : (archiving ? "Archiving" : "Archive")
                    },
                    {
                      show: !!integration,
                      type: 'custom',
                      children: [
                        customer.CustomerSyncStatus === Enums.SyncStatus.Pending ?
                            <Button disabled={true}
                            >
                              Sync pending to {Enums.getEnumStringValue(Enums.IntegrationPartner, integration?.Partner)}
                            </Button> :
                            customer.CustomerSyncStatus === Enums.SyncStatus.Synced ?
                                <Button disabled={true}
                                >
                                  Synced
                                </Button> :
                                customer.CustomerSyncStatus === Enums.SyncStatus.Deleted ?
                                <Button disabled={true}
                                >
                                  Deleted
                                </Button> :
                                customer.IsActive && customer.CustomerSyncStatus === Enums.SyncStatus.Failed ?
                                    <>
                                      <Button
                                          disabled={accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess || integration?.Status !== Enums.IntegrationStatus.Live}
                                          leftSection={<IconSend />}
                                          rightSection={<AlertIcon message={customer?.CustomerSyncMessage} />}
                                          tooltip={integrationTooltip}
                                          onClick={() => syncCustomer()}
                                      >
                                        Retry sync to {Enums.getEnumStringValue(Enums.IntegrationPartner, integration?.Partner)}
                                      </Button>
                                      {/*<HelpDialog position="bottom" message={`${}`} width={175}/>*/}
                                    </> : ''
                      ]
                    },
                  ],
                  [
                    {
                      breakpoint: 480,
                      type: 'button',
                      text: 'Cancel',
                      hideIcon: true,
                      variant: 'outline',
                      icon: <IconArrowBackUp />,
                      onClick: cancel,
                    }
                  ],
                  [
                    {
                      breakpoint: 480,
                      type: 'button',
                      icon: <IconDeviceFloppy/>,
                      isBusy: saving,
                      disabled: saveDisabled,
                      text: saving ? "Saving" : "Save",
                      onClick: saving ? null : () => saveCustomer((false as any)),
                    }
                  ]
              ]}
          />

          {/*<div className="actions">

            <ButtonDropdown
                disabled={accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess}
                action={optionsClick}
                text="Options"
                options={optionButtons}
            /> ✅

            {customer.IsArchived
                ? <LegacyButton disabled={saveDisabled}
                          text={archiving ? "Un-archiving" : "Archived"}
                          icon="archive-white"
                          extraClasses="grey-action auto"
                          onClick={archiving ? null : archiveCustomer}
                />
                :
                <LegacyButton disabled={saveDisabled}
                        text={archiving ? "Archiving" : "Archive"} icon="archive" extraClasses="white-action auto"
                        onClick={archiving ? null : archiveCustomer}/>
            } ✅

            {integration ?
                customer.CustomerSyncStatus == Enums.SyncStatus.Pending ?
                    <LegacyButton disabled={true}
                            text={`Sync pending to ${Enums.getEnumStringValue(Enums.IntegrationPartner, integration?.Partner)}`}
                            extraClasses="auto"/> :
                    customer.CustomerSyncStatus == Enums.SyncStatus.Synced ?
                        <LegacyButton disabled={true} text={`Synced`} extraClasses="auto"/> :
                        customer.IsActive && customer.CustomerSyncStatus == Enums.SyncStatus.Failed ?
                            <>
                              <LegacyButton
                                  disabled={accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess || integration?.Status !== Enums.IntegrationStatus.Live}
                                  text={`Retry sync to ${Enums.getEnumStringValue(Enums.IntegrationPartner, integration?.Partner)}`}
                                  icon="send" extraClasses="white-action auto"
                                  tooltip={integrationTooltip}
                                  onClick={() => syncCustomer()}/>
                              <HelpDialog position="bottom" message={`${customer.CustomerSyncMessage}`} width={175}/>
                            </> : '' : ''
            } ✅

            <LegacyButton text="Cancel" extraClasses="auto hollow" onClick={cancel}/> ✅
            <LegacyButton disabled={saveDisabled} text={saving ? "Saving" : "Save"}
                    onClick={saving ? null : () => saveCustomer(false)} extraClasses="auto"/>
          </div>*/}
        </Flex>

        <Tabs
            selectedTab={selectedTab}
            setSelectedTab={trySetSelectedTab}
            tabs={pageTabs}
            useNewTabs
            tabsProps={
              {mt: {base: 'sm', xl: 0}, mx: {base: 1, sm: 'xs', md: 'sm', lg: 'md'}}
            }
        />
      </Box>

      <Box
          bg={'gray.1'}
          py={{base: 5, xs: 8, sm: 'md'}}
          px={{base: 5, xs: 8}}
          mih={`calc(100vh - ${(toolbarHeight ? (toolbarHeight + 68) : 166)}px)`}
      >
        <Card
            p={'md'}
            px={{base: 1, xs: 5, sm: 'sm'}}
            radius={'md'}
        >
          {(() => {
            switch (selectedTab) {
              case 'Details':
                return <>
                  {!customer.IsActive && !customer.IsArchived &&
                    <Flex data-testid={'customer-hidden-banner'} align={'center'} gap={10} bg={'gray.1'} c={'gray.9'}
                          px={12} py={10} mb={18} maw={1020} style={{borderRadius: 'var(--mantine-radius-sm)'}}>
                      <IconEyeOff size={18} style={{flex: 'none'}} />
                      <Text size={'sm'} style={{flex: 1}}>This customer is hidden. It won't display for you or anyone on your team.</Text>
                      {editCustomerPermission && !saveDisabled &&
                        <Button size={'compact-sm'} variant={'outline'} color={'gray.9'} loading={togglingActive} onClick={toggleActive}>
                          Show this customer
                        </Button>}
                    </Flex>}
                  <CustomerForm
                    triggerSaveComment={triggerSaveComment}
                    customer={customer}
                    accessStatus={accessStatus}
                    editCustomerPermission={editCustomerPermission}

                    triggerFormSaveCounter={triggerFormSaveCounter}
                    onSaveValues={(values: any) => handleSaveCustomer(values)}
                    onDirtyStateChange={(dirty: any) => {
                      if (!cclDirty || dirty) {
                        setFormIsDirty(dirty)
                      }
                    }}
                    onErrors={(errors: any) => handleErrors(errors)}
                    updateCustomer={(newCustomer: any, setDirty: any) => {
                      setCustomer(newCustomer)
                      setContacts(newCustomer.Contacts)
                      setLocations(newCustomer.Locations)
                      if (setDirty) {
                        setCclDirty(true)
                        setFormIsDirty(true)
                      }
                    }}

                  />
                </>;
              case 'Contacts':
                return <>
                  <ItemContactsTable
                      module={Enums.Module.Customer}
                      customerId={customer.ID}
                      accessStatus={accessStatus}
                      canEdit={editCustomerPermission}
                      moduleData={customer}
                      updateModuleData={fetchCustomerDetails}
                  />
                  {/*<Contacts contacts={contacts} module={Enums.Module.Customer} moduleData={customer}
                            updateModuleData={fetchCustomerDetails} accessStatus={accessStatus}
                            editCustomerPermission={editCustomerPermission}
                  />*/}
                </>
              case 'Locations':
                return <>
                  <CustomerLocationsTable
                      module={Enums.Module.Customer}
                      customerId={customer.ID}
                      accessStatus={accessStatus}
                      canEdit={editCustomerPermission}
                      moduleData={customer}
                      updateModuleData={fetchCustomerDetails}
                  />
                  {/*<Locations locations={locations} module={Enums.Module.Customer} moduleData={customer}
                             updateModuleData={fetchCustomerDetails} accessStatus={accessStatus}
                             canEdit={editCustomerPermission} />*/}

                </>
              case 'Jobs':
                return <ItemJobsTable module={Enums.Module.Customer} itemId={customer.ID} customerId={customer.ID}
                             accessStatus={accessStatus}/>;
              case 'Quotes':
                return <ItemQuotesTable module={Enums.Module.Customer} itemId={customer.ID} customerId={customer.ID}
                               accessStatus={accessStatus} onUpdated={getCounts}/>;
              case 'Invoices':
                return <ItemInvoicesTable module={Enums.Module.Customer} itemId={customer.ID} customerId={customer.ID}
                                 accessStatus={accessStatus}/>;
              case 'Queries':
                return <>
                  <ItemQueriesTable module={Enums.Module.Customer} itemId={customer.ID} customerId={customer.ID}
                                    accessStatus={accessStatus}
                  />
                </>

              case 'Assets':
                return <>
                  <ItemAssetsTable module={Enums.Module.Customer} itemId={customer.ID} customerId={customer.ID}
                                   accessStatus={accessStatus} />
                  {/*<Products module={Enums.Module.Customer} moduleID={customer.ID} accessStatus={accessStatus}/>;*/}
                </>
              case 'Appointments':
                return <Appointments topMargin={false} accessStatus={accessStatus} customerID={customer.ID} module={Enums.Module.Customer} moduleID={customer.ID} onRefresh={onAppointmentRefresh} />;
              case 'Attachments':
                return <Attachments topMargin={false} displayName={customer.CustomerName} itemId={customer.ID} module={Enums.Module.Customer} onRefresh={onAttachmentRefresh} accessStatus={accessStatus} />;
              case 'Messages':
                return <Communications topMargin={false} itemId={customer.ID} module={Enums.Module.Customer} customerID={customer.ID} selectedContact={customer?.Contacts?.find((c: any) => c.IsPrimary) || customer?.Contacts?.[0]} accessStatus={accessStatus} />;
              default:
                return null;
            }
          })()}
        </Card>
      </Box>

      <QuoteDrawer
          customerID={!!createNewCopyQuote ? undefined : customer.ID}
          module={!!createNewCopyQuote ? undefined : Enums.Module.Customer}
          moduleID={!!createNewCopyQuote ? undefined : customer.ID}
          quote={selectedQuote}
          isNew={createNewQuote}
          show={createNewQuote || !!selectedQuote}
          onClose={
            () => {
              setSelectedQuote(null)
              setCreateNewQuote(false)
              setCreateNewCopyQuote(null)
            }
          }
          onSaved={getCounts}
          onCreated={(q: any, close: any) => {
            if(!close) {
              setSelectedQuote(q)
            }
            setCreateNewQuote(false)
            setCreateNewCopyQuote(null)
            getCounts()
          }}
          accessStatus={accessStatus}
          company={companyDetails}
          copyFromQuote={createNewCopyQuote}
          onCopyToQuote={(q: any) => {
            setCreateNewQuote(true)
            setSelectedQuote(null)
            setCreateNewCopyQuote(q)
          }}
          onCreateNew={
            () => {
              setCreateNewQuote(true)
              setSelectedQuote(null)
              setCreateNewCopyQuote(null)
            }
          }
          setIsNew={setCreateNewQuote}
      />

      <InvoiceDrawer
          customerID={!!createNewCopyInvoice ? undefined : customer.ID}
          module={!!createNewCopyInvoice ? undefined : Enums.Module.Customer}
          moduleID={!!createNewCopyInvoice ? undefined : customer.ID}
          invoice={selectedInvoice}
          isNew={createNewInvoice}
          show={createNewInvoice || !!selectedInvoice}
          onClose={
            () => {
              setSelectedInvoice(null)
              setCreateNewInvoice(false)
              setCreateNewCopyInvoice(null)
            }
          }
          onSaved={getCounts}
          onCreated={(q: any, close: any) => {
            if(!close) {
              setSelectedInvoice(q)
            }
            setCreateNewInvoice(false)
            setCreateNewCopyInvoice(null)
            getCounts()
          }}
          accessStatus={accessStatus}
          company={companyDetails}
          copyFromInvoice={createNewCopyInvoice}
          onCopyToInvoice={(q: any) => {
            setCreateNewInvoice(true)
            setSelectedInvoice(null)
            setCreateNewCopyInvoice(q)
          }}
          onCreateNew={
            () => {
              setCreateNewInvoice(true)
              setSelectedInvoice(null)
              setCreateNewCopyInvoice(null)
            }
          }
          setIsNew={setCreateNewInvoice}
      />
      
      {showFormsModal &&
        <FormDefinitionsForItem
          customer={customer}
          onClose={() => setShowFormsModal(false)}
          itemID={customer.ID}
          itemModule={Enums.Module.Customer}
          linkedFormDefinitions={[]}
          onlyLinkedForms={false}
          {...{} as any}
        />
      }

      <ConfirmAction options={confirmOptions} setOptions={setConfirmOptions} />

      <style jsx>{`
        .title {
          align-items: center;
          color: ${colors.darkPrimary};
          display: flex;
          width: 100%;
        }
        .title h1 {
          font-size: 32px;
          margin: 6px 0 0 0;
        }
        .title p {
          font-size: 14px;
          margin: 0;
        }
        .row {
          display: flex;
        }
        .actions {
          display: flex;
        }
        .actions :global(.button){
          margin-left: 0.5rem;
          margin-top: 0;
          padding: 0 1rem;
          white-space: nowrap;
        }
      `}</style>
    </div>
  );
}

export default CustomerPage;

export const Route = createFileRoute('/_authenticated/customer/$id')({ component: CustomerPage })
